import * as constants from "../../constants";
import environment from "../../environments/environment";
import { setLoginDetails } from "../../store/features/auth/authSlice";
import { axiosInterceptor } from "../fiscalUpgrade/services/authInterceptor";

export const refreshToken = async (homeaccountId: string, dispatch: any, navigate: any) => {
  try {
    const response = await axiosInterceptor.get(`${environment.refresh_tocken_base_url}?accountId=${homeaccountId}&app=FISCAL`);
    if (response.status === constants.STATUS_CODES.SUCCESS) {
      const newResponseData = response.data.data;
      const userInfo = {
        isLogin: true,
        jwtToken: newResponseData.accessToken,
        refreshToken: newResponseData.refreshToken,
        expiresIn: newResponseData.expiresIn,
        expiresOn: newResponseData.expiresOn,
        userName: `${newResponseData.userInfo.name}`,
        firstName: newResponseData.userInfo.givenName,
        lastName: newResponseData.userInfo.familyName,
        emailId: newResponseData.userInfo.displayableId,
        language: newResponseData.userInfo.language,
        menuPosition: newResponseData.userInfo.menuPosition,
        tenantId: newResponseData.userInfo.displayableId.split("@")[1],
        homeAccountId: newResponseData.userInfo.homeAccountId,
      };
      dispatch(setLoginDetails(userInfo));
      return response;
    } else {
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    // Redirect to root (./) when error occurs 
    navigate('./');
    throw error; // Rethrow the error after navigation if needed
  }
};
